(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initReveal(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('.agt-reveal');

    if (!sections.length) return;

    if (prefersReducedMotion()) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );

    sections.forEach((section) => {
      if (!section.classList.contains('is-visible')) {
        observer.observe(section);
      }
    });
  }

  function initFadeUp(root) {
    const scope = root || document;
    const items = scope.querySelectorAll('.agt-fade-up');

    if (!items.length) return;

    if (prefersReducedMotion()) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => {
      if (!item.classList.contains('is-visible')) {
        observer.observe(item);
      }
    });
  }

  function initHeaderTransparentOnScroll(root) {
    const scope = root || document;
    const wrappers = scope.querySelectorAll('.header-wrapper--solid-on-scroll');

    if (!wrappers.length) return;

    function update() {
      wrappers.forEach((wrapper) => {
        if (window.scrollY > 20) {
          wrapper.classList.add('is-scrolled');
        } else {
          wrapper.classList.remove('is-scrolled');
        }
      });
    }

    update();

    if (!window.__agtHeaderScrollBound) {
      window.addEventListener('scroll', update, { passive: true });
      window.__agtHeaderScrollBound = true;
    }
  }

  function initSection(root) {
    initReveal(root);
    initFadeUp(root);
    initHeaderTransparentOnScroll(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSection(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const section = event.target.closest('.shopify-section');
    if (section) initSection(section);
  });
})();